import React from "react";
import Attachments from "../BasicInfo/Attachments";
import PropTypes from "prop-types";

const ExhibitionAttachments = ({ attachments, onAttachmentsUpdated }) => (
  <Attachments
    attachments={attachments}
    type={"exhibition"}
    onAttachmentsUpdated={onAttachmentsUpdated}
  />
);

ExhibitionAttachments.propTypes = {
  attachments: PropTypes.array,
  onAttachmentsUpdated: PropTypes.func,
};

export default ExhibitionAttachments;
